import axiosInstance from "../../lib/axiosInstance";

import {
  setLoadingPermissions,
  setErrorLoadingPermissions,
  setPermissions,
} from "../slices/permission";
import { getErrorMessage } from "../../utils/errorUtils";

export const getPermissions = () => async (dispatch) => {
  dispatch(setLoadingPermissions());
  try {
    const { data } = await axiosInstance.get("/permissions", {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setPermissions(data.data.permissions));
    }
  } catch (error) {
    dispatch(setErrorLoadingPermissions(getErrorMessage(error)));
  }
};
